import { $toast } from "vuetify-snackbar-toast";

const MENSAGEM_DE_FALHA = "Não foi possível completar a operação. Tente novamente.";

export default function $handleError(error) {
  const mensagem = error?.message || error?.error?.message || MENSAGEM_DE_FALHA;

  if (!mensagem.includes("Unauthenticated")) {
    $toast.danger(mensagem);
  }
}

export const handleErrorPlugin = (vue) => {
  vue.prototype.$handleError = $handleError;
};
